import React from 'react'
import './AppDownloadModal.css'
import Modal from 'react-bootstrap/Modal'
import AppDownloadQRCode from '../AppDownloadQRCode'
import { useTheme } from '../../context/ThemeContext'
import { IOS_APP_URL, ANDROID_APP_URL } from '../../pages/DownloadRedirect'

interface AppDownloadModalProps {
  show: boolean
  onHide: () => void
}

const AppDownloadModal: React.FC<AppDownloadModalProps> = ({ show, onHide }) => {
  const { theme } = useTheme()

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      contentClassName={theme === 'dark' ? 'app-download-modal-dark' : ''}
    >
      <Modal.Header className={theme === 'dark' ? 'app-download-modal-dark' : ''}>
        <Modal.Title className={theme === 'dark' ? 'white__text' : ''}>
          Download b4i
          <span className="b4igo-blue">g</span>
          <span className="b4igo-blue">o </span>
          Mobile App
        </Modal.Title>
        <i className={`bi bi-x-lg modal-icon-custom ${theme === 'dark' ? 'close' : ''}`} onClick={onHide}></i>
      </Modal.Header>
      <Modal.Body className={`text-center ${theme === 'dark' ? 'app-download-modal-dark' : ''}`}>
        <p className={`mb-4 d-flex align-items-center justify-content-center gap-2 ${theme === 'dark' ? 'text-muted' : 'text-gray-600'}`}>
          <img src="/media/logos/orange-robot-bold.svg" alt="b4igo robot" className="b4igo-robo-img" />
          Scan the QR code with your phone to download the app
        </p>

        {/* One QR for both stores — /download sniffs the user agent and sends
            the phone to the right one. Never make the scanner pick. */}
        <AppDownloadQRCode
          size={250}
          includeLogo={true}
          level="H"
          showTitle={false}
          showDescription={false}
        />
        <p className={`mt-3 ${theme === 'dark' ? 'text-muted' : 'text-gray-600'}`} style={{ fontSize: 'var(--fs-body-sm)' }}>
          Opens the App Store or Google Play, whichever your phone uses
        </p>

        {/* Download Buttons */}
        <div className='d-flex justify-content-center gap-3 mt-4'>
          <a
            href={IOS_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className='btn btn-sm d-flex align-items-center gap-2'
            style={{
              backgroundColor: theme === 'dark' ? '#2B2B40' : '#000000',
              color: '#FFFFFF',
              padding: '8px 16px',
              borderRadius: '8px',
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#FFFFFF">
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
            </svg>
            App Store
          </a>
          <a
            href={ANDROID_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className='btn btn-sm d-flex align-items-center gap-2'
            style={{
              backgroundColor: theme === 'dark' ? '#2B2B40' : '#01875F',
              color: '#FFFFFF',
              padding: '8px 16px',
              borderRadius: '8px',
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#FFFFFF">
              <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.802 8.99l-2.303 2.303-8.635-8.635z" />
            </svg>
            Google Play
          </a>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AppDownloadModal